import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SectionKey } from '../types';
import { SectionNavigationState } from 'js/reducers/app/sectionNavigationReducer';

/**
 * Repository hook for section navigation state
 * Provides read access to section navigation state from Redux
 */
export default function useSectionNavigationRepository() {
  const sectionNavigation = useSelector(
    (state: any): SectionNavigationState => state.app?.sectionNavigation || {},
  );

  const getLastVisitedPath = useMemo(
    () =>
      (section: SectionKey): string | null => {
        return sectionNavigation[section] || null;
      },
    [sectionNavigation],
  );

  return {
    sectionNavigation,
    getLastVisitedPath,
  };
}
